class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
    this.timer = null
    this.delay = 4000
    this.dl = document.querySelector('gtm-datalayer')

    this.initialize()
  }

  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)
    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach(el => {
      this.listeners.add(el, 'click', this.onLinkClick.bind(this))
    })
  }

  initialize () {
    this.announcements = this.els.announcement.elements

    // Start the cycle on desktop only - ticker animation used on mobile
    this.debouncedResize = window.BAO.utils.debounce(event => {
      this.setupTickerSpeed(event)

      if (window.matchMedia('(max-width: 900px)').matches) return
      this.startCycle(event)
    }, 240)

    this.listeners.add(window, 'load', this.debouncedResize)
    this.listeners.add(window, 'resize', this.debouncedResize)

    // Pause on hover (desktop only)
    this.addEventListener('mouseenter', () => this.stopCycle())
    this.addEventListener('mouseleave', () => this.startCycle())
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 50
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }

  startCycle () {
    // Start the cycle on desktop only - ticker animation used on mobile
    if (window.matchMedia('(max-width: 900px)').matches) return

    this.stopCycle()
    if (this.announcements.length < 2) return

    this.timer = setInterval(() => this.showNext(), this.delay)
  }

  stopCycle () {
    clearInterval(this.timer)
  }

  showNext () {
    const total = this.announcements.length
    this.announcements[this.currentIndex].setAttribute('aria-hidden', true)
    this.currentIndex = (this.currentIndex + 1) % total
    this.announcements[this.currentIndex].removeAttribute('aria-hidden')
  }

  onLinkClick (ev) {
    if (!this.dl) return

    const text = ev.target.innerText
    const event = new CustomEvent('gtmPush', {
      detail: {
        event: 'announcement_bar_interaction',
        target_text: text,
        target_index: this.currentIndex,
      },
    })

    this.dl.dispatchEvent(event)
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
